/**
 * Constant selectors for PBI Embedded Report
 */
export const PAGE_HEADER_ID = "pageHeader";
export const PAGE_SECTION_ID = "pageSection";
export const PREDICTION_SUMMARY_ID = "predictionSummary";
export const REPORT_CLASS_NAME = "pbi-report";
// https://dev.azure.com/bst10/BigData/_workitems/edit/42539
export const REPORT_MARGINS = 20; // powerbi's extra margins
export const CARDS_REPORT_ID = "pbiCard";
export const REPORT_CONTAINER_MIN_SIZE = 550;
